
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWifistrengt0Google as ObiWifistrengt0GoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wifistrengt-0-google.js';
 
 
 

 
 export const ObiWifistrengt0Google = createComponent({
   react: React,
   tagName: 'obi-wifistrengt-0-google',
   elementClass: ObiWifistrengt0GoogleElement,
   events: {
     
   }
  });
 
 